module.exports = __webpack_public_path__ + "static/media/37.d13e306b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/37.jpg
// module id = 983
// module chunks = 0